<template>
  <footer class="footer">
    © 2024 PT Mitra Pengadaan
  </footer>
</template>
<script>
export default {
  
}
</script>